import { render, staticRenderFns } from "./FInfo.vue?vue&type=template&id=3db0d036&"
import script from "./FInfo.vue?vue&type=script&lang=js&"
export * from "./FInfo.vue?vue&type=script&lang=js&"
import style0 from "./FInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports